<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center mt-0 pb-5>
        <v-flex xs12 md8>
          <v-card
            style="
              background-color: transparent !important;
              border: 0px solid red !important;
            "
            flat
          >
            <v-card-title class="pt-6 pb-0 px-0 mb-3" v-if="!loadingList.about">
              <user-list-item
                :item="userData"
                :avatar="userData.Avatar"
                :avatarSize="'100'"
                :fullName="userData.FullName"
                :department="userData.Department"
                :company="userData.Company"
                :noBg="true"
                :divider="false"
                :buttonVisible="true"
                :buttonText="$t('buttons.changePhoto')"
                :buttonDisabled="false"
                :buttonTypeText="true"
                :width="'100%'"
                @sendMessage="(n) => (menu = !menu)"
              />

              <v-layout
                style="position: absolute; right: 175px; top: 105px"
                v-if="menu"
              >
                <v-menu
                  flat
                  v-model="menu"
                  :close-on-content-click="true"
                  :nudge-width="150"
                  transition="slide-y-transition"
                  origin="top"
                  attach
                  z-index="11"
                >
                  <v-list dense>
                    <template>
                      <input
                        type="file"
                        accept="image/*"
                        ref="uploader"
                        class="d-none"
                        @change="onFileChange"
                      />
                      <v-list-item
                        class="py-2 font-weight-medium defaultColor--text"
                        style="font-size: 13px"
                        link
                        @click="changePhoto()"
                      >
                        <v-list-item-content class="pl-3">
                          {{ $t("buttons.selectPhoto") }}
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider />
                      <v-list-item
                        class="py-2 font-weight-medium defaultColor--text"
                        style="font-size: 13px"
                        link
                        @click="deletePhoto()"
                      >
                        <v-list-item-content class="pl-3">
                          {{ $t("buttons.deletePhoto") }}
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </v-layout>
            </v-card-title>

            <v-card-title class="pt-1 pb-0 px-0 mb-2">
              <story-banner
                :userId="$store.state.userId"
                :isProfileStories="true"
              ></story-banner>
            </v-card-title>
          </v-card>

          <v-tabs
            v-model="tab"
            background-color="transparent"
            grow
            color="defaultColor"
            style="border-bottom: 1px solid grey !important"
          >
            <v-tab v-for="tabItem in tabItems" :key="tabItem.data">
              {{ tabItem.title }}
            </v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="tab"
            style="background-color: transparent !important"
          >
            <v-tab-item :value="0">
              <loading-progress :status="loadingList.about" />
              <div v-if="!loadingList.about">
                <v-list-item class="mt-7">
                  <v-list-item-content>
                    <v-list-item-title
                      style="font-size: 14px"
                      class="defaultColorLight--text font-weight-regular mb-3"
                      >{{ $t("labels.sicilNumber") }}</v-list-item-title
                    >
                    <v-list-item-subtitle
                      style="font-size: 16px"
                      class="defaultColor--text font-weight-bold"
                    >
                      {{ userData.Username }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="my-7" />
                <v-list-item class="mb-7">
                  <v-list-item-content>
                    <v-list-item-title
                      style="font-size: 14px"
                      class="defaultColorLight--text font-weight-regular mb-3"
                      >{{ $t("labels.area") }}</v-list-item-title
                    >
                    <v-list-item-subtitle
                      style="font-size: 16px"
                      class="defaultColor--text font-weight-bold"
                    >
                      {{ userData.Area }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      style="font-size: 16px"
                      class="defaultColor--text font-weight-bold"
                    >
                      {{ userData.Company }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-card class="greyCard" flat v-if="!updateUserInfo">
                  <v-list-item class="mb-7 pt-6 px-13">
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size: 14px"
                        class="defaultColor--text font-weight-regular mb-3"
                        >{{ $t("labels.birthdate") }}</v-list-item-title
                      >
                      <v-list-item-subtitle
                        style="font-size: 16px"
                        class="defaultColor--text font-weight-bold"
                      >
                        {{
                          moment(userData.DateOfBirth)
                            .locale("tr")
                            .format("DD MMMM YYYY")
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider class="my-3" />

                  <v-list-item class="mb-7 px-13">
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size: 14px"
                        class="defaultColor--text font-weight-regular mb-3"
                        >{{ $t("labels.about") }}</v-list-item-title
                      >
                      <v-list-item-subtitle
                        style="font-size: 16px"
                        class="defaultColor--text font-weight-bold"
                      >
                        {{ userData.About }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider class="my-3" />

                  <v-list-item class="mb-7 px-13 pb-6">
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size: 14px"
                        class="defaultColor--text font-weight-regular mb-3"
                        >{{ $t("labels.phone") }}</v-list-item-title
                      >
                      <v-list-item-subtitle
                        style="font-size: 16px"
                        class="defaultColor--text font-weight-bold"
                      >
                        {{ userData.Phone }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>

                <v-card class="outlineCard mb-6" flat v-if="updateUserInfo">
                  <v-text-field
                    class="mb-3 mt-10 px-13"
                    v-model="userUpdateData.birthdate"
                    disabled
                    :label="$t('labels.birthdate')"
                    height="67"
                    style="border-radius: 100px"
                    rounded
                    outlined
                    dense
                  ></v-text-field>

                  <v-text-field
                    v-model="userUpdateData.about"
                    class="mb-3 px-13"
                    :label="$t('labels.about')"
                    height="67"
                    style="border-radius: 100px"
                    rounded
                    outlined
                    dense
                  ></v-text-field>

                  <v-text-field
                    v-model="userUpdateData.phone"
                    class="mb-5 px-13"
                    :label="$t('labels.phone')"
                    height="67"
                    style="border-radius: 100px"
                    rounded
                    outlined
                    dense
                  ></v-text-field>
                </v-card>

                <v-layout justify-center align-center mb-10 column>
                  <v-btn
                    color="defaultColor"
                    class="white--text text-capitalize mr-3 font-weight-light px-10"
                    elevation="0"
                    rounded
                    large
                    :disabled="disabledSaveButton"
                    @click="clickProfilAboutButton"
                  >
                    {{
                      !updateUserInfo
                        ? $t("buttons.update")
                        : $t("buttons.save")
                    }}
                  </v-btn>
                  <span class="my-8 defaultColor--text" style="font-size: 12px">
                    {{
                      moment(userData.CreatedAt)
                        .locale("tr")
                        .format("DD MMMM YYYY") + " tarihinde katıldı."
                    }}
                  </span>
                  <v-btn
                    color="redColor"
                    class="white--text text-capitalize mr-3 font-weight-light px-10"
                    elevation="0"
                    outlined
                    rounded
                    large
                    @click="logout()"
                  >
                    {{ $t("buttons.logout") }}
                  </v-btn>
                </v-layout>
              </div>
            </v-tab-item>
            <v-tab-item :value="1">
              <loading-progress :status="loadingList.myPosts" />
              <div
                v-for="(item, index) in myPostData"
                :key="index"
                class="mt-6"
              >
                <feed-item-card
                  class="test-diagno mb-5"
                  :itemData="item"
                  :index="index"
                />
              </div>
              <div
                class="text-center"
                v-if="myPostData.length > 0 && !moreButtonHiddenMyPost"
              >
                <v-btn
                  text
                  color="primary"
                  @click="loadMoreMyPost()"
                  class="text-capitalize mt-2"
                >
                  {{ $t("buttons.more") }}
                </v-btn>
              </div>
            </v-tab-item>
            <v-tab-item :value="2">
              <loading-progress :status="loadingList.myLike" />
              <div
                v-for="(item, index) in myLikedData"
                :key="index"
                class="mt-6"
              >
                <feed-item-card
                  class="test-diagno mb-5"
                  :itemData="item"
                  :index="index"
                />
              </div>
              <div
                class="text-center"
                v-if="myLikedData.length > 0 && !moreButtonHiddenMyLiked"
              >
                <v-btn
                  text
                  color="primary"
                  @click="loadMoreMyLiked()"
                  class="text-capitalize mt-2"
                >
                  {{ $t("buttons.more") }}
                </v-btn>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import UserService from "../../services/UserService";
import ContentService from "../../services/ContentService";
import UserListItem from "../../components/Users/UserListItem.vue";
import FeedItemCard from "../../components/Feeds/FeedItemCard.vue";
import StoryBanner from "../../components/Stories/StoryBanner.vue";
import { mapActions } from "vuex";
export default {
  data: function () {
    {
      return {
        tab: 0,

        tabItems: [
          { title: this.$t("tabs.myAbout"), data: "about" },
          { title: this.$t("tabs.myPost"), data: "myPosts" },
          { title: this.$t("tabs.myLike"), data: "myLike" },
        ],

        loadingList: {
          about: true,
          myPosts: true,
          myLike: true,
        },

        userId: null,
        userData: null,

        menu: false,

        updateUserInfo: false,
        userUpdateData: {
          birthdate: "",
          about: "",
          phone: "",
        },

        myPostData: [],
        myPostPage: 1,
        myPostPageSize: 10,
        moreButtonHiddenMyPost: false,

        myLikedData: [],
        myLikedPage: 1,
        myLikedPageSize: 10,
        moreButtonHiddenMyLiked: false,
      };
    }
  },
  components: {
    LoadingProgress,
    UserListItem,
    FeedItemCard,
    StoryBanner,
  },
  methods: {
    getUserAbout() {
      this.loadingList.about = true;
      UserService.getUserInfo(this.userId)
        .then((res) => {
          console.log("user about :", res.data);
          let area = res.data.Groups.filter((x) => x.Type === "Region");
          this.userData = res.data;
          this.userData.Area = area.length > 0 ? area[0].Name : "";
          this.$store.state.user.Avatar = res.data.Avatar;
          let obj = {
            birthdate: this.moment(res.data.DateOfBirth)
              .locale("tr")
              .format("DD MMMM YYYY"),
            about: res.data.About,
            phone: res.data.Phone,
          };
          this.userUpdateData = obj;
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          this.loadingList.about = false;
        });
    },

    changePhoto() {
      this.$refs.uploader.click();
    },

    onFileChange(e) {
      if (e.target.files[0] === undefined) {
      } else {
        if (e.target.files[0].size < 20971520) {
          this.uploadPhoto(e.target.files[0]);
        } else {
          //20 mb'dan büyükse
          showWarning(this.$t("description.uploadLessFile", { count: 20 }));
        }
      }
      e.target.value = "";
    },

    uploadPhoto(media) {
      if (media === undefined) {
        console.log("Undefined media");
        showWarning(this.$t("description.unexpected"));
      } else {
        let formData = new FormData();
        formData.append("Files", media);
        formData.append("Type", "media");
        setPageLoading(true);
        UserService.changeProfilePhoto(formData)
          .then((res) => {
            this.userData.Avatar = res.data.LocalUrl;
            this.$store.state.user.Avatar = res.data.LocalUrl;
          })
          .catch((err) => {
            console.log(err);
            showError(err);
          })
          .then(() => {
            setPageLoading(false);
          });
      }
    },

    deletePhoto() {
      let body = {
        IsAvatarRemove: true,
      };

      UserService.updateUserInfo(this.userId, body)
        .then((res) => {
          this.getUserAbout();
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {});
    },

    clickProfilAboutButton() {
      if (!this.updateUserInfo) {
        this.updateUserInfo = true;
      } else {
        if (
          this.userUpdateData.about == this.userData.About &&
          this.userUpdateData.phone == this.userData.Phone
        ) {
          this.updateUserInfo = false;
        } else {
          this.updateUser();
        }
      }
    },

    updateUser() {
      let body = {
        About:
          this.userUpdateData.about.length > 0 || ""
            ? this.userUpdateData.about
            : "empty",
        Phone:
          this.userUpdateData.phone.length > 0 || ""
            ? this.userUpdateData.phone
            : "empty",
      };

      UserService.updateUserInfo(this.userId, body)
        .then((res) => {
          this.userData.About = body.About;
          this.userData.Phone = body.Phone;
          this.updateUserInfo = false;
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {});
    },

    getProfilePost(id) {
      this.loadingList.myPosts = true;
      ContentService.getProfilePost(id, this.myPostPage, this.myPostPageSize)
        .then((res) => {
          console.log("profile post :", res.data);
          let data = res.data.Data;
          if (this.myPostPage !== 1) {
            this.myPostData = [...this.myPostData, ...data];
          } else {
            this.myPostData = data;
          }
          if (data.length <= 0) {
            this.moreButtonHidden = true;
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          this.loadingList.myPosts = false;
        });
    },

    getProfileLiked() {
      this.loadingList.myLike = true;
      UserService.getProfileLikedPosts(this.myLikedPage, this.myLikedPageSize)
        .then((res) => {
          console.log("profile liked :", res.data);
          let data = res.data.Result;
          if (this.myLikedPage !== 1) {
            this.myLikedData = [...this.myLikedData, ...data];
          } else {
            this.myLikedData = data;
          }
          if (data.length <= 0) {
            this.moreButtonHiddenMyLiked = true;
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          this.loadingList.myLike = false;
        });
    },

    loadMoreMyPost() {
      this.myPostPage++;
      this.getProfilePost(this.userId);
    },

    loadMoreMyLiked() {
      this.myLikedPage++;
      this.getProfileLiked(this.userId);
    },

    ...mapActions(["logout"]),
  },
  computed: {
    disabledSaveButton() {
      if (this.updateUserInfo) {
        if (this.userUpdateData.phone == "" || this.userUpdateData.about == "")
          return true;
        else return false;
      } else {
        return false;
      }
    },
  },
  destroyed() {},
  mounted() {
    this.userId = this.$store.state.userId;

    this.getUserAbout();
    this.getProfilePost(this.userId);
    this.getProfileLiked();

    setTimeout(() => {
      if (this.$route.query.tab) {
        console.log("this.$route.query.tab :", this.$route.query.tab);
        this.tab = parseInt(this.$route.query.tab);
      }
    }, 500);
  },
  watch: {},
};
</script>

<style></style>
